import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class FlipCoinGameImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /flip-coin-game/games */
  public getFlipCoinGameGames(query?: {
    status?: ('INITIAL' | 'PENDING' | 'STARTED' | 'COMPLETED' | 'CANCELED')[];
    limit?: number;
    offset?: number;
    ownerAddress?: string;
    userAddress?: string;
    sort?: string;
  }) {
    return this.makeRequest<API.FlipCoinGameWebsocketResponseModel>(`flip-coin-game/games`, {
      method: 'GET',
      query: {
        ...query,
        status: query?.status?.join(',')
      }
    });
  }

  /** GET /flip-coin-game/token-config */
  public getFlipCoinGameTokenConfig(query: { tokenAddress?: string }) {
    return this.makeRequest<API.FlipCoinTokenConfigResponseModel>(`flip-coin-game/token-config`, {
      method: 'GET',
      query
    });
  }

  /** PUT /flip-coin-game/{gameId}/confirm */
  public putFlipCoinGameByGameIdConfirm(gameId: string) {
    return this.makeRequest<API.FlipCoinGameDtoSchema>(`flip-coin-game/${encodeURIComponent(String(gameId))}/confirm`, {
      method: 'PUT'
    });
  }

  /** POST /flip-coin-game/initial */
  public postFlipCoinGameInitial(body: {
    ownerPlayer: string;
    tokenAddress: string;
    transactionHash: string;
    isOddBet: boolean;
    betAmount: number;
  }) {
    return this.makeRequest<API.FlipCoinGameDtoSchema>(`flip-coin-game/initial`, {
      method: 'POST',
      body
    });
  }

  /** GET /flip-coin-game/games/{gameId} */
  public getFlipCoinGameGamesByGameId(gameId: string) {
    return this.makeRequest<API.FlipCoinGameHistoryItemSchema>(
      `flip-coin-game/games/${encodeURIComponent(String(gameId))}`,
      {
        method: 'GET'
      }
    );
  }
}
